import { render, staticRenderFns } from "./SmartLessonOverview.vue?vue&type=template&id=064fdb4c&scoped=true"
import script from "./SmartLessonOverview.vue?vue&type=script&lang=js"
export * from "./SmartLessonOverview.vue?vue&type=script&lang=js"
import style0 from "./SmartLessonOverview.vue?vue&type=style&index=0&id=064fdb4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064fdb4c",
  null
  
)

export default component.exports